<div *ngIf="process.messages && process.messages.length">
    <h4 class="md-subhead">Messages:</h4>
    <div class="scrollableMessages">
        <p *ngFor="let message of process.messages">{{message}}</p>
    </div>
</div>
